import { GET_LIST_HUYEN, GET_LIST_XA, GET_LIST_DON_VI_BY_ID } from 'constants/ActionTypes';

export const getDSHuyen = maDonVi => {
  return {
    type: GET_LIST_HUYEN,
    payload: { maDonVi: maDonVi }
  }
}

export const getDSXa = maHuyen => {
  return {
    types: GET_LIST_XA,
    payload: { maDonVi: maHuyen }
  }
}

export const getDonViTheoId = maDonVi => {
  return {
    types: GET_LIST_DON_VI_BY_ID,
    payload: { maDonVi }
  }
}
